"use client";
import { useQuery } from '@tanstack/react-query';
import PleaseWait from '@/components/loader/PleaseWait';
import Shows from '@/components/program/Shows';
import { getCultureProgram } from '@/lib/client/movieinfo';
import styles from "./ShowsForCulture.module.css";




//#region [Props]
type ShowsForCultureProps = {
    kulnr: string;
    nynorsk: boolean;
};
//#endregion

//#region [Component]
export default function ShowsForCulture({ kulnr, nynorsk }: ShowsForCultureProps) {
    const { isLoading, data } = useQuery({
        queryKey: ["culture", kulnr], // key
        queryFn: () => getCultureProgram(kulnr, undefined, false), // loader function
        refetchOnWindowFocus: false,
        refetchInterval: 600000, // refretch automatically every 10 minutes
        staleTime: 599999,
    } // options
    );
    return (<section className={styles.CultureProgram}>
        <h1 className={styles.ProgramTitle}>{nynorsk ? "Framsyningar" : "Forestillinger"}</h1>
        {isLoading && <PleaseWait text="Henter programmet" />}
        {!isLoading && (data?.shows?.length ?? 0) === 0 && <p className={styles.NoShows}>{nynorsk ? "framsyningar" : "forestillinger"}</p>}
        {!isLoading && (data?.shows?.length ?? 0) > 0 && <Shows data={data} />}

    </section>);
}
//#endregion